const env = document.querySelector("meta[name=env]").content

export default env
